import React from "react";
import { Box, Stack } from "@mui/material";

import Logo from "../../images/managekaro footer.png";
import { Text, Title } from "../../pages/landing page/style";

function Footer() {
  return (
    <Box sx={{ background: "#2E2C2C", p: { xs: "15px", md: "72px 83px" } }}>
      <Stack spacing={2.4} mb={5}>
        {/* <Stack direction="row" width="100%" justifyContent="space-between">
          <Title sx={{ fontSize: "24px", color: "#FAFAFA99" }}>Call Now</Title>
          <Title sx={{ fontSize: "24px", color: "#FAFAFA99" }}>Location</Title>
        </Stack> */}
        <Box
          sx={{
            height: "1px",
            background:
              "linear-gradient(270deg, rgba(46, 44, 44, 0.9) 0%, #A8A8A8 52.6%, rgba(46, 44, 44, 0.9) 100%)",
          }}
        ></Box>
        <Stack
          direction="row"
          width="100%"
          justifyContent="space-between"
          spacing={1}
        >
          <Stack maxWidth="45%">
            <Title sx={{ fontSize: "24px", color: "#FAFAFA99" }}>
              Call Now
            </Title>
            <Text sx={{ color: "#FAFAFA99" }}>+92 331 592 1209</Text>
            {/* <Text sx={{ color: "#FAFAFA99" }}>+44 7403 228448</Text> */}
          </Stack>
          <Box sx={{ maxWidth: "45%" }}>
            <Title sx={{ fontSize: "24px", color: "#FAFAFA99" }}>
              Location
            </Title>
            <Stack alignItems="flex-end" width="100%">
              <Text sx={{ color: "#FAFAFA99" }}>
                National Science & Technology Park. H12 - Islamabad Pakistan
              </Text>
              <Text sx={{ color: "#FAFAFA99" }}>
                Gower St, London WC1E 6BT, London, EC2A 2BB United Kingdom
              </Text>
            </Stack>
          </Box>
        </Stack>
      </Stack>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          margin: "0 auto",
          width: { xs: "90%", sm: "50%", md: "35%" },
        }}
      >
        <img style={{ width: "100%" }} src={Logo} alt="" />
      </Box>
    </Box>
  );
}

export default Footer;
